import { Alert } from 'actions';

const initialState = {
  isVisible: false,
  msg: null,
  type: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Alert.ALERT_SHOW:
      return {
        isVisible: true,
        type: action.alert.type,
        msg: action.alert.msg,
      };
    case Alert.ALERT_HIDE:
      return initialState;
    default:
      return state;
  }
}
